import {Link} from "react-router-dom";
import {NavItemTenant} from "./NavItemTenant";
import HttpRequest from "../../Http/HttpRequest";
import Notify from "../../Notify/Notify";
import {CurrentTitle} from "./CurrentTitle";
import {useContext} from "react";
import {UserContext} from "../../Context/UserContext";

export const MyNav = () => {

    const {currentUser} = useContext(UserContext);

    const logout = async () => {
        console.log('do logout');
        await HttpRequest.post('node/auth/logout', {});
        Notify.success("Deslogado!");
        setTimeout(() => {
            window.location = '/'
        }, 300);
    }

    return (
        <nav className="main-header navbar navbar-expand">
            <ul className="navbar-nav">

                <li className="nav-item">
                    <Link className="nav-link" to="" data-widget="pushmenu"
                          onClick={e => e.preventDefault()} role="button"><i
                        className="fas fa-bars"/></Link>
                </li>

                <li className="nav-item">
                    <Link className="nav-link" to="/">
                        <i className="fas fa-home"/></Link>
                </li>
            </ul>

            <ul className="navbar-nav ml-auto">
                <CurrentTitle/>
            </ul>
            <ul className="navbar-nav ml-auto">

                {currentUser &&   <NavItemTenant/>}

                {currentUser && <li className="nav-item">
                    <Link to="/" onClick={logout} className="nav-link" role="button"
                          title="Sair">
                        <i className="fas fa-sign-out-alt"/>
                    </Link>
                </li>
                }

            </ul>
        </nav>)

}
